"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reportWebSession = void 0;
const extraction_1 = require("./extraction");
const reporting_1 = require("./reporting");
const types_1 = require("./types");
const graphene_1 = __importDefault(require("@snapchat/graphene"));
const web_sentry_1 = require("@snapchat/web-sentry");
const web_env_1 = require("@snapchat/web-env");
const serverReportingEndpointSuffix = "/web-session";
function buildWebSessionEvent({ pageLoadTtfb = 0, pageLoadFcp = 0, pageLoadCls = 0, pageLoadFid = 0, pageLoadLcp = 0, pageType, webClientId, }) {
    if (!webClientId) {
        if ((0, web_env_1.isRunningOnDevEnv)()) {
            console.error("Missing params for WebSession event");
        }
        if (graphene_1.default.isReady()) {
            graphene_1.default.increment({
                metricsName: `BlizzardEvents.WebSession.MissingParams.${types_1.PageType[pageType]}`,
                value: 1,
            });
        }
        (0, web_sentry_1.logSentryError)("Missing params for WebSession Blizzard Event");
        return;
    }
    return {
        webServerEventBase: (0, extraction_1.extractWebServerEventBase)(pageType, webClientId),
        pageLoadTtfb: Math.round(pageLoadTtfb).toString(),
        pageLoadFcp: Math.round(pageLoadFcp).toString(),
        // CLS is a score between 0 and 1, extract upto 3 significant digits
        pageLoadCls: Math.round(pageLoadCls * 1000).toString(),
        pageLoadFid: Math.round(pageLoadFid).toString(),
        pageLoadLcp: Math.round(pageLoadLcp).toString(),
        sessionLengthTimer: Math.round(performance.now()).toString(),
    };
}
// Session id is added in https://github.sc-corp.net/Snapchat/web/blob/f4c9cd06fc08ff7e63f0dfecf1805b6e57d14a95/common/blizzard-reporting/extraction.ts#L58-L58
function reportWebSession(params) {
    const webSessionEvent = buildWebSessionEvent(params);
    if (webSessionEvent) {
        (0, reporting_1.reportServerEvent)(serverReportingEndpointSuffix, webSessionEvent);
    }
}
exports.reportWebSession = reportWebSession;
//# sourceMappingURL=WebSession.js.map